import { useEffect, useRef, useState } from 'react';

import { useIsMobile } from '@common/hooks';

import { useSidebar } from './hooks';
import SidebarNavIndicator from './SidebarNavIndicator';
import SidebarNavItem from './SidebarNavItem';
import type { ISidebarProps } from './types';

import style from './styles.module.scss';

const Sidebar = ({ activeId, slideRefs, sectionData: sections = [] }: ISidebarProps) => {
  const itemRefs = useRef<Record<string, HTMLLIElement | null>>({});
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const isMobile = useIsMobile();

  const { indicator, isClickActive, onHandleClick, updateIndicator } = useSidebar({
    activeId,
    selectedId,
    setSelectedId,
    slideRefs,
    isMobile,
  });

  // Sync indicator when activeId or click state changes
  useEffect(() => {
    const idToShow = !isClickActive ? activeId : selectedId;
    if (idToShow) {
      updateIndicator(idToShow, itemRefs);
    }
  }, [activeId, selectedId, isClickActive, updateIndicator]);

  return (
    <aside className={style.sidebar}>
      <nav
        className={style['sidebar-nav']}
        aria-label="Report Sections Nav"
      >
        <ul>
          {sections.map((section) => {
            return (
              <SidebarNavItem
                key={section.id}
                ref={(el) => {
                  itemRefs.current[section.id] = el;
                }}
                section={section}
                isActive={section.id === activeId}
                isMobile={isMobile}
                onClick={() => {
                  return onHandleClick(section.id);
                }}
              />
            );
          })}
        </ul>

        {!isMobile && (
          <SidebarNavIndicator
            top={indicator.top}
            height={indicator.height}
          />
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
